module.exports = __webpack_public_path__ + "static/media/smartAsn-berAKHLAK.1559d46d.svg";